import {getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'
import {EntityFactory} from '@modifi/redux'

import {AppThunkAction} from '../../../types/redux'

const apiClient = getAuthenticatedThemisClient()

const {actions, reducer, selectors} = EntityFactory({
  actionNamePrefix: 'data/publicRegisteredCompany/resolution',
  rootSelector: state => state?.data?.publicRegisteredCompanies?.resolvedCompany,
  fetchRequest: () => apiClient?.PublicRegisteredCompanies.fetchResolved().then(res => res.data()),
})

export default reducer

export const selectResolvedPublicRegisteredCompanyDetails = selectors.selectEntity

export const selectResolvedPublicRegisteredCompanyDetailsAreLoading = selectors.selectIsLoading

const aFetchResolvedPublicRegisteredCompanyDetails = (): AppThunkAction => actions.fetch()

export const aEnsureFetchResolvedPublicRegisteredCompanyDetails =
  (): AppThunkAction<void> =>
  (dispatch, getState): void => {
    const publicRegisteredCompanyDetails = selectResolvedPublicRegisteredCompanyDetails(getState())
    if (!publicRegisteredCompanyDetails?.providerDetails) {
      dispatch(aFetchResolvedPublicRegisteredCompanyDetails())
    }
  }
